import React from 'react';
import './StatusCard.scss';
import Button from '../Button/Button';
import Check from '../../../assets/icons/Check';

const StatusCard = ({status, title, text, buttonText, buttonOnClick}) => {
    return (
        <div className={'status-card-container'}>
            <div className={'flex-aligned-justified-center v2-column gap-8'}>
                {status === 'success' ?
                <div className={'status-card-outer-circle'}>
                    <div className={'status-card-inner-circle'}>
                        <Check height={'44px'} width={'44px'}/>
                    </div>
                </div> : <h1>Not yet implemented</h1>
                }
                <p className={'h3 v2-c-primary-500'}>{title}</p>
                {text}
            </div>
            <Button size={'large'} onClick={buttonOnClick} variant={'primary'}>{buttonText}</Button>
        </div>

    );
};
export default StatusCard;
